<header class="header">
  <div class="container-fluid header__container">
    <h2 class="header__title">Аналитика менеджеров</h2>
    <div class="header__control">
      <span>Диапазон дат:</span>
      <input type="text" class="datepicker-here form-control"/>
    </div>
  </div>
</header>
